function initMenu() {
	
	
	const menu = document.querySelector('nav#main-menu');
	const menu_toggle = document.querySelector('header button.menu');
	const menu_toggle_label = menu_toggle.querySelector('.label');
	const menu_toggle_burger = menu_toggle.querySelector('.burger');
	const label_closed = 'Open menu';
	const label_open = 'Close menu';
	let menu_open = menu_toggle.getAttribute('aria-expanded') === 'true';
	
	function openMenu() {
		menu_toggle.setAttribute('aria-expanded', true);
		menu_toggle_label.textContent = label_open;
		menu_toggle_burger.classList.add('toggled');
		menu.classList.add('open');
		menu.inert = false;
		menu_open = true;
	}
	
	function closeMenu() {
		menu_toggle.setAttribute('aria-expanded', false);
		menu_toggle_label.textContent = label_closed;
		menu_toggle_burger.classList.remove('toggled');
		menu.classList.remove('open');
		menu.inert = true;
		menu_open = false;
	}
	
	// toggle
	menu_toggle.addEventListener('click', (e)=>{
		e.stopPropagation();
		if(!menu_open) openMenu();
		else closeMenu();	
	});
	
	// close on click outside
	document.addEventListener('click', (e)=>{
		if(menu_open && !menu.contains(e.target)) {
			closeMenu();
		}
	});
	
	// close with esc
	document.addEventListener('keydown', (e)=>{
		if(menu_open && (e.key === 'Escape')) {
			closeMenu();
		}
	});

}
initMenu();

  